module.exports = __webpack_public_path__ + "static/media/bye.e9026d01.png";